module.exports = __webpack_public_path__ + "static/media/funcional.d259cf18.jpg";